import { isNotDefined, getMACalculator } from "../utils";
import { PriceOscillator as defaultOptions } from "./defaultOptionsForComputation";

export default function () {
  let options = defaultOptions;

  function calculator(data) {
    const { shortPeriod, longPeriod, sourcePath, movingAverageType, mode } =
      options;

    // Get MA calculator using centralized utility
    const maCalculator = getMACalculator(movingAverageType);

    // Calculate Short MA and Long MA
    const shortMA = maCalculator().options({
      windowSize: shortPeriod,
      sourcePath,
    })(data);
    const longMA = maCalculator().options({
      windowSize: longPeriod,
      sourcePath,
    })(data);

    // Calculate Price Oscillator
    const oscillatorValues = data.map((d, i) => {
      const shortValue = shortMA[i];
      const longValue = longMA[i];

      if (
        isNotDefined(shortValue) ||
        isNotDefined(longValue) ||
        longValue === 0
      ) {
        return undefined;
      }

      let result;
      if (mode === "Points") {
        // Points mode: Short MA - Long MA
        result = shortValue - longValue;
      } else {
        // Percent mode (default): 100 * ((Short MA / Long MA) - 1)
        result = 100 * (shortValue / longValue - 1);
      }

      return result;
    });

    return oscillatorValues;
  }

  calculator.undefinedLength = function () {
    return Math.max(options.shortPeriod, options.longPeriod) - 1;
  };

  calculator.options = function (x) {
    if (!arguments.length) {
      return options;
    }
    options = { ...defaultOptions, ...x };
    return calculator;
  };

  return calculator;
}
